module.exports = __webpack_public_path__ + "static/media/main-bird.39ac67a7.png";